export default __webpack_public_path__ + "static/media/logoNoLimitWhite.5cbf133e.svg";